import {Box, Show, Stack, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNil, isNotNil} from 'ramda';

interface FinancialProductCardProps {
  controls?: ReactNode;
  result: ReactNode;
  footer?: ReactNode;
}

export function FinancialProductCard(props: FinancialProductCardProps) {
  return (
    <VStack spacing={4}>
      <Box
        border="thin solid"
        borderColor="border.emphasisDefault"
        borderRadius="medium"
        overflow="hidden"
      >
        <Stack direction={['column', 'column', 'row']} spacing={0}>
          <Show when={isNotNil(props.controls)}>
            <Box flexGrow={1} flexShrink={1} flexBasis="58%" padding={6} minWidth={0}>
              <VStack spacing={7} justify="space-between" height="100%">
                {props.controls}
                {props.footer}
              </VStack>
            </Box>
          </Show>
          <Box
            flexGrow={1}
            flexShrink={1}
            flexBasis={isNil(props.controls) ? '100%' : '42%'}
            minWidth={0}
          >
            {props.result}
          </Box>
        </Stack>
      </Box>
      <Show when={isNil(props.controls)}>{props.footer}</Show>
    </VStack>
  );
}
